import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { Assesment } from '@services/assesment';
import { ParkArea } from '@services/park-area';
import { ParkAreaAssesmentAnswer } from '@services/park-area-assesment-answer';
import { ParkAreaAssesmentStatus } from './park-area-assesment-status.enum';

export class ParkAreaAssesment extends BaseEntity {
	assesmentId: string;

	@Type(() => Assesment)
	assesment: Assesment;

	parkAreaId: string;

	@Type(() => ParkArea)
	parkArea: ParkArea;

	@Type(() => ParkAreaAssesmentAnswer)
	parkAreaAssesmentAnswers: ParkAreaAssesmentAnswer[];

	status: ParkAreaAssesmentStatus;
}
